import * as Yup from "yup"

import { messages } from "utils/messages"

const schema = Yup.object({
  name: Yup.string().max(70, messages.max_chars(70)).required(messages.required),
  providers: Yup.array(),
  bar_code: Yup.string().max(30, messages.max_chars(30)).required(messages.required),
  sat_code: Yup.string().max(255, messages.max_chars(255)).required(messages.required),
  cost: Yup.string().required(messages.required),
  prices: Yup.array().of(Yup.object()).nullable(),
  brand: Yup.object().nullable(),
  unit_measurement: Yup.object().nullable().required(messages.required),
  taxes: Yup.array(),
})

export default schema
